/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppAccessRouteRouteImport } from './routes/app/access/route'
import { Route as AppGuideRouteImport } from './routes/app/guide'
import { Route as AppListsRouteImport } from './routes/app/lists'
import { Route as AppReportsRouteImport } from './routes/app/reports'
import { Route as AppRtasRouteImport } from './routes/app/rtas'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppAccessIndexRouteImport } from './routes/app/access/index'
import { Route as AppAccessDirectoryRouteImport } from './routes/app/access/directory'
import { Route as AppAccessRolesRouteImport } from './routes/app/access/roles'
import { Route as AppAccessUsersRouteImport } from './routes/app/access/users'
import { Route as AppAccountsIndexRouteImport } from './routes/app/accounts/index'
import { Route as AppAccountsAccountIdRouteImport } from './routes/app/accounts/$accountId'
import { Route as AppTemplatesIndexRouteImport } from './routes/app/templates/index'
import { Route as AppTemplatesTemplateIdRouteImport } from './routes/app/templates/$templateId'
import { Route as AppTopicsIndexRouteImport } from './routes/app/topics/index'
import { Route as AppAccountsAccountIdAnalyticsRouteImport } from './routes/app/accounts/$accountId_.analytics'
import { Route as AppAccountsAccountIdLibraryRouteImport } from './routes/app/accounts/$accountId_.library'
import { Route as AppAccountsAccountIdSettingsRouteImport } from './routes/app/accounts/$accountId_.settings'
import { Route as AppAccountsAccountIdStreamConfigRouteImport } from './routes/app/accounts/$accountId_.stream-config'
import { Route as AppAccountsAccountIdCoverageListsIndexRouteImport } from './routes/app/accounts/$accountId_.coverage-lists.index'
import { Route as AppAccountsAccountIdReportsIndexRouteImport } from './routes/app/accounts/$accountId_.reports.index'
import { Route as AppAccountsAccountIdReportsReportIdRouteImport } from './routes/app/accounts/$accountId_.reports.$reportId'
import { Route as AppAccountsAccountIdRtasIndexRouteImport } from './routes/app/accounts/$accountId_.rtas.index'
import { Route as AppAccountsAccountIdRtasRtaIdRouteImport } from './routes/app/accounts/$accountId_.rtas.$rtaId'
import { Route as AppAccountsAccountIdTemplatesIndexRouteImport } from './routes/app/accounts/$accountId_.templates.index'
import { Route as AppAccountsAccountIdTemplatesTemplateIdRouteImport } from './routes/app/accounts/$accountId_.templates.$templateId'
import { Route as AppAccountsAccountIdTopicsIndexRouteImport } from './routes/app/accounts/$accountId_.topics.index'
import { Route as AppAccountsAccountIdSubaccountsSubaccountIdIndexRouteImport } from './routes/app/accounts/$accountId_.subaccounts.$subaccountId.index'
import { Route as AppAccountsAccountIdSubaccountsSubaccountIdAnalyticsRouteImport } from './routes/app/accounts/$accountId_.subaccounts.$subaccountId.analytics'
import { Route as AppAccountsAccountIdSubaccountsSubaccountIdCoverageListsRouteImport } from './routes/app/accounts/$accountId_.subaccounts.$subaccountId.coverage-lists'
import { Route as AppAccountsAccountIdSubaccountsSubaccountIdLibraryRouteImport } from './routes/app/accounts/$accountId_.subaccounts.$subaccountId.library'
import { Route as AppAccountsAccountIdSubaccountsSubaccountIdReportsRouteImport } from './routes/app/accounts/$accountId_.subaccounts.$subaccountId.reports'
import { Route as AppAccountsAccountIdSubaccountsSubaccountIdRtasRouteImport } from './routes/app/accounts/$accountId_.subaccounts.$subaccountId.rtas'
import { Route as AppAccountsAccountIdSubaccountsSubaccountIdStreamConfigRouteImport } from './routes/app/accounts/$accountId_.subaccounts.$subaccountId.stream-config'
import { Route as AppAccountsAccountIdSubaccountsSubaccountIdTemplatesRouteImport } from './routes/app/accounts/$accountId_.subaccounts.$subaccountId.templates'
import { Route as AppAccountsAccountIdTopicsSubaccountIdIndexRouteImport } from './routes/app/accounts/$accountId_.topics.$subaccountId.index'
import { Route as AppAccountsAccountIdTopicsSubaccountIdNewRouteImport } from './routes/app/accounts/$accountId_.topics.$subaccountId.new'
import { Route as AppAccountsAccountIdTopicsSubaccountIdResourcesRouteImport } from './routes/app/accounts/$accountId_.topics.$subaccountId.resources'
import { Route as AppAccountsAccountIdReportsReportIdIssuesIndexRouteImport } from './routes/app/accounts/$accountId_.reports.$reportId_.issues.index'
import { Route as AppAccountsAccountIdReportsReportIdIssuesIssueIdRouteImport } from './routes/app/accounts/$accountId_.reports.$reportId_.issues.$issueId'
import { Route as AppAccountsAccountIdTopicsSubaccountIdTopicIdIndexRouteImport } from './routes/app/accounts/$accountId_.topics.$subaccountId.$topicId.index'
import { Route as AppAccountsAccountIdTopicsSubaccountIdTopicIdEditRouteImport } from './routes/app/accounts/$accountId_.topics.$subaccountId.$topicId.edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccessRouteRoute = AppAccessRouteRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGuideRoute = AppGuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppListsRoute = AppListsRouteImport.update({
  id: '/lists',
  path: '/lists',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRtasRoute = AppRtasRouteImport.update({
  id: '/rtas',
  path: '/rtas',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccessIndexRoute = AppAccessIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccessRouteRoute,
} as any)
const AppAccessDirectoryRoute = AppAccessDirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => AppAccessRouteRoute,
} as any)
const AppAccessRolesRoute = AppAccessRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppAccessRouteRoute,
} as any)
const AppAccessUsersRoute = AppAccessUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAccessRouteRoute,
} as any)
const AppAccountsIndexRoute = AppAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccountsAccountIdRoute = AppAccountsAccountIdRouteImport.update({
  id: '/accounts/$accountId',
  path: '/accounts/$accountId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTemplatesIndexRoute = AppTemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTemplatesTemplateIdRoute = AppTemplatesTemplateIdRouteImport.update({
  id: '/templates/$templateId',
  path: '/templates/$templateId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTopicsIndexRoute = AppTopicsIndexRouteImport.update({
  id: '/topics/',
  path: '/topics/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccountsAccountIdAnalyticsRoute =
  AppAccountsAccountIdAnalyticsRouteImport.update({
    id: '/accounts/$accountId_/analytics',
    path: '/accounts/$accountId/analytics',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdLibraryRoute =
  AppAccountsAccountIdLibraryRouteImport.update({
    id: '/accounts/$accountId_/library',
    path: '/accounts/$accountId/library',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdSettingsRoute =
  AppAccountsAccountIdSettingsRouteImport.update({
    id: '/accounts/$accountId_/settings',
    path: '/accounts/$accountId/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdStreamConfigRoute =
  AppAccountsAccountIdStreamConfigRouteImport.update({
    id: '/accounts/$accountId_/stream-config',
    path: '/accounts/$accountId/stream-config',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdCoverageListsIndexRoute =
  AppAccountsAccountIdCoverageListsIndexRouteImport.update({
    id: '/accounts/$accountId_/coverage-lists/',
    path: '/accounts/$accountId/coverage-lists/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdReportsIndexRoute =
  AppAccountsAccountIdReportsIndexRouteImport.update({
    id: '/accounts/$accountId_/reports/',
    path: '/accounts/$accountId/reports/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdReportsReportIdRoute =
  AppAccountsAccountIdReportsReportIdRouteImport.update({
    id: '/accounts/$accountId_/reports/$reportId',
    path: '/accounts/$accountId/reports/$reportId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdRtasIndexRoute =
  AppAccountsAccountIdRtasIndexRouteImport.update({
    id: '/accounts/$accountId_/rtas/',
    path: '/accounts/$accountId/rtas/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdRtasRtaIdRoute =
  AppAccountsAccountIdRtasRtaIdRouteImport.update({
    id: '/accounts/$accountId_/rtas/$rtaId',
    path: '/accounts/$accountId/rtas/$rtaId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdTemplatesIndexRoute =
  AppAccountsAccountIdTemplatesIndexRouteImport.update({
    id: '/accounts/$accountId_/templates/',
    path: '/accounts/$accountId/templates/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdTemplatesTemplateIdRoute =
  AppAccountsAccountIdTemplatesTemplateIdRouteImport.update({
    id: '/accounts/$accountId_/templates/$templateId',
    path: '/accounts/$accountId/templates/$templateId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdTopicsIndexRoute =
  AppAccountsAccountIdTopicsIndexRouteImport.update({
    id: '/accounts/$accountId_/topics/',
    path: '/accounts/$accountId/topics/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdSubaccountsSubaccountIdIndexRoute =
  AppAccountsAccountIdSubaccountsSubaccountIdIndexRouteImport.update({
    id: '/accounts/$accountId_/subaccounts/$subaccountId/',
    path: '/accounts/$accountId/subaccounts/$subaccountId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdSubaccountsSubaccountIdAnalyticsRoute =
  AppAccountsAccountIdSubaccountsSubaccountIdAnalyticsRouteImport.update({
    id: '/accounts/$accountId_/subaccounts/$subaccountId/analytics',
    path: '/accounts/$accountId/subaccounts/$subaccountId/analytics',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdSubaccountsSubaccountIdCoverageListsRoute =
  AppAccountsAccountIdSubaccountsSubaccountIdCoverageListsRouteImport.update({
    id: '/accounts/$accountId_/subaccounts/$subaccountId/coverage-lists',
    path: '/accounts/$accountId/subaccounts/$subaccountId/coverage-lists',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdSubaccountsSubaccountIdLibraryRoute =
  AppAccountsAccountIdSubaccountsSubaccountIdLibraryRouteImport.update({
    id: '/accounts/$accountId_/subaccounts/$subaccountId/library',
    path: '/accounts/$accountId/subaccounts/$subaccountId/library',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdSubaccountsSubaccountIdReportsRoute =
  AppAccountsAccountIdSubaccountsSubaccountIdReportsRouteImport.update({
    id: '/accounts/$accountId_/subaccounts/$subaccountId/reports',
    path: '/accounts/$accountId/subaccounts/$subaccountId/reports',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdSubaccountsSubaccountIdRtasRoute =
  AppAccountsAccountIdSubaccountsSubaccountIdRtasRouteImport.update({
    id: '/accounts/$accountId_/subaccounts/$subaccountId/rtas',
    path: '/accounts/$accountId/subaccounts/$subaccountId/rtas',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdSubaccountsSubaccountIdStreamConfigRoute =
  AppAccountsAccountIdSubaccountsSubaccountIdStreamConfigRouteImport.update({
    id: '/accounts/$accountId_/subaccounts/$subaccountId/stream-config',
    path: '/accounts/$accountId/subaccounts/$subaccountId/stream-config',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdSubaccountsSubaccountIdTemplatesRoute =
  AppAccountsAccountIdSubaccountsSubaccountIdTemplatesRouteImport.update({
    id: '/accounts/$accountId_/subaccounts/$subaccountId/templates',
    path: '/accounts/$accountId/subaccounts/$subaccountId/templates',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdTopicsSubaccountIdIndexRoute =
  AppAccountsAccountIdTopicsSubaccountIdIndexRouteImport.update({
    id: '/accounts/$accountId_/topics/$subaccountId/',
    path: '/accounts/$accountId/topics/$subaccountId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdTopicsSubaccountIdNewRoute =
  AppAccountsAccountIdTopicsSubaccountIdNewRouteImport.update({
    id: '/accounts/$accountId_/topics/$subaccountId/new',
    path: '/accounts/$accountId/topics/$subaccountId/new',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdTopicsSubaccountIdResourcesRoute =
  AppAccountsAccountIdTopicsSubaccountIdResourcesRouteImport.update({
    id: '/accounts/$accountId_/topics/$subaccountId/resources',
    path: '/accounts/$accountId/topics/$subaccountId/resources',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdReportsReportIdIssuesIndexRoute =
  AppAccountsAccountIdReportsReportIdIssuesIndexRouteImport.update({
    id: '/accounts/$accountId_/reports/$reportId_/issues/',
    path: '/accounts/$accountId/reports/$reportId/issues/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdReportsReportIdIssuesIssueIdRoute =
  AppAccountsAccountIdReportsReportIdIssuesIssueIdRouteImport.update({
    id: '/accounts/$accountId_/reports/$reportId_/issues/$issueId',
    path: '/accounts/$accountId/reports/$reportId/issues/$issueId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdTopicsSubaccountIdTopicIdIndexRoute =
  AppAccountsAccountIdTopicsSubaccountIdTopicIdIndexRouteImport.update({
    id: '/accounts/$accountId_/topics/$subaccountId/$topicId/',
    path: '/accounts/$accountId/topics/$subaccountId/$topicId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountsAccountIdTopicsSubaccountIdTopicIdEditRoute =
  AppAccountsAccountIdTopicsSubaccountIdTopicIdEditRouteImport.update({
    id: '/accounts/$accountId_/topics/$subaccountId/$topicId/edit',
    path: '/accounts/$accountId/topics/$subaccountId/$topicId/edit',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/app/access': typeof AppAccessRouteRouteWithChildren
  '/app/guide': typeof AppGuideRoute
  '/app/lists': typeof AppListsRoute
  '/app/reports': typeof AppReportsRoute
  '/app/rtas': typeof AppRtasRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/': typeof AppIndexRoute
  '/app/access/directory': typeof AppAccessDirectoryRoute
  '/app/access/roles': typeof AppAccessRolesRoute
  '/app/access/users': typeof AppAccessUsersRoute
  '/app/accounts/$accountId': typeof AppAccountsAccountIdRoute
  '/app/templates/$templateId': typeof AppTemplatesTemplateIdRoute
  '/app/access/': typeof AppAccessIndexRoute
  '/app/accounts/': typeof AppAccountsIndexRoute
  '/app/templates/': typeof AppTemplatesIndexRoute
  '/app/topics/': typeof AppTopicsIndexRoute
  '/app/accounts/$accountId/analytics': typeof AppAccountsAccountIdAnalyticsRoute
  '/app/accounts/$accountId/library': typeof AppAccountsAccountIdLibraryRoute
  '/app/accounts/$accountId/settings': typeof AppAccountsAccountIdSettingsRoute
  '/app/accounts/$accountId/stream-config': typeof AppAccountsAccountIdStreamConfigRoute
  '/app/accounts/$accountId/reports/$reportId': typeof AppAccountsAccountIdReportsReportIdRoute
  '/app/accounts/$accountId/rtas/$rtaId': typeof AppAccountsAccountIdRtasRtaIdRoute
  '/app/accounts/$accountId/templates/$templateId': typeof AppAccountsAccountIdTemplatesTemplateIdRoute
  '/app/accounts/$accountId/coverage-lists/': typeof AppAccountsAccountIdCoverageListsIndexRoute
  '/app/accounts/$accountId/reports/': typeof AppAccountsAccountIdReportsIndexRoute
  '/app/accounts/$accountId/rtas/': typeof AppAccountsAccountIdRtasIndexRoute
  '/app/accounts/$accountId/templates/': typeof AppAccountsAccountIdTemplatesIndexRoute
  '/app/accounts/$accountId/topics/': typeof AppAccountsAccountIdTopicsIndexRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/analytics': typeof AppAccountsAccountIdSubaccountsSubaccountIdAnalyticsRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/coverage-lists': typeof AppAccountsAccountIdSubaccountsSubaccountIdCoverageListsRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/library': typeof AppAccountsAccountIdSubaccountsSubaccountIdLibraryRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/reports': typeof AppAccountsAccountIdSubaccountsSubaccountIdReportsRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/rtas': typeof AppAccountsAccountIdSubaccountsSubaccountIdRtasRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/stream-config': typeof AppAccountsAccountIdSubaccountsSubaccountIdStreamConfigRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/templates': typeof AppAccountsAccountIdSubaccountsSubaccountIdTemplatesRoute
  '/app/accounts/$accountId/topics/$subaccountId/new': typeof AppAccountsAccountIdTopicsSubaccountIdNewRoute
  '/app/accounts/$accountId/topics/$subaccountId/resources': typeof AppAccountsAccountIdTopicsSubaccountIdResourcesRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/': typeof AppAccountsAccountIdSubaccountsSubaccountIdIndexRoute
  '/app/accounts/$accountId/topics/$subaccountId/': typeof AppAccountsAccountIdTopicsSubaccountIdIndexRoute
  '/app/accounts/$accountId/reports/$reportId/issues/$issueId': typeof AppAccountsAccountIdReportsReportIdIssuesIssueIdRoute
  '/app/accounts/$accountId/topics/$subaccountId/$topicId/edit': typeof AppAccountsAccountIdTopicsSubaccountIdTopicIdEditRoute
  '/app/accounts/$accountId/reports/$reportId/issues/': typeof AppAccountsAccountIdReportsReportIdIssuesIndexRoute
  '/app/accounts/$accountId/topics/$subaccountId/$topicId/': typeof AppAccountsAccountIdTopicsSubaccountIdTopicIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app/guide': typeof AppGuideRoute
  '/app/lists': typeof AppListsRoute
  '/app/reports': typeof AppReportsRoute
  '/app/rtas': typeof AppRtasRoute
  '/app/settings': typeof AppSettingsRoute
  '/app': typeof AppIndexRoute
  '/app/access/directory': typeof AppAccessDirectoryRoute
  '/app/access/roles': typeof AppAccessRolesRoute
  '/app/access/users': typeof AppAccessUsersRoute
  '/app/accounts/$accountId': typeof AppAccountsAccountIdRoute
  '/app/templates/$templateId': typeof AppTemplatesTemplateIdRoute
  '/app/access': typeof AppAccessIndexRoute
  '/app/accounts': typeof AppAccountsIndexRoute
  '/app/templates': typeof AppTemplatesIndexRoute
  '/app/topics': typeof AppTopicsIndexRoute
  '/app/accounts/$accountId/analytics': typeof AppAccountsAccountIdAnalyticsRoute
  '/app/accounts/$accountId/library': typeof AppAccountsAccountIdLibraryRoute
  '/app/accounts/$accountId/settings': typeof AppAccountsAccountIdSettingsRoute
  '/app/accounts/$accountId/stream-config': typeof AppAccountsAccountIdStreamConfigRoute
  '/app/accounts/$accountId/reports/$reportId': typeof AppAccountsAccountIdReportsReportIdRoute
  '/app/accounts/$accountId/rtas/$rtaId': typeof AppAccountsAccountIdRtasRtaIdRoute
  '/app/accounts/$accountId/templates/$templateId': typeof AppAccountsAccountIdTemplatesTemplateIdRoute
  '/app/accounts/$accountId/coverage-lists': typeof AppAccountsAccountIdCoverageListsIndexRoute
  '/app/accounts/$accountId/reports': typeof AppAccountsAccountIdReportsIndexRoute
  '/app/accounts/$accountId/rtas': typeof AppAccountsAccountIdRtasIndexRoute
  '/app/accounts/$accountId/templates': typeof AppAccountsAccountIdTemplatesIndexRoute
  '/app/accounts/$accountId/topics': typeof AppAccountsAccountIdTopicsIndexRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/analytics': typeof AppAccountsAccountIdSubaccountsSubaccountIdAnalyticsRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/coverage-lists': typeof AppAccountsAccountIdSubaccountsSubaccountIdCoverageListsRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/library': typeof AppAccountsAccountIdSubaccountsSubaccountIdLibraryRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/reports': typeof AppAccountsAccountIdSubaccountsSubaccountIdReportsRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/rtas': typeof AppAccountsAccountIdSubaccountsSubaccountIdRtasRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/stream-config': typeof AppAccountsAccountIdSubaccountsSubaccountIdStreamConfigRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId/templates': typeof AppAccountsAccountIdSubaccountsSubaccountIdTemplatesRoute
  '/app/accounts/$accountId/topics/$subaccountId/new': typeof AppAccountsAccountIdTopicsSubaccountIdNewRoute
  '/app/accounts/$accountId/topics/$subaccountId/resources': typeof AppAccountsAccountIdTopicsSubaccountIdResourcesRoute
  '/app/accounts/$accountId/subaccounts/$subaccountId': typeof AppAccountsAccountIdSubaccountsSubaccountIdIndexRoute
  '/app/accounts/$accountId/topics/$subaccountId': typeof AppAccountsAccountIdTopicsSubaccountIdIndexRoute
  '/app/accounts/$accountId/reports/$reportId/issues/$issueId': typeof AppAccountsAccountIdReportsReportIdIssuesIssueIdRoute
  '/app/accounts/$accountId/topics/$subaccountId/$topicId/edit': typeof AppAccountsAccountIdTopicsSubaccountIdTopicIdEditRoute
  '/app/accounts/$accountId/reports/$reportId/issues': typeof AppAccountsAccountIdReportsReportIdIssuesIndexRoute
  '/app/accounts/$accountId/topics/$subaccountId/$topicId': typeof AppAccountsAccountIdTopicsSubaccountIdTopicIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/app/access': typeof AppAccessRouteRouteWithChildren
  '/app/guide': typeof AppGuideRoute
  '/app/lists': typeof AppListsRoute
  '/app/reports': typeof AppReportsRoute
  '/app/rtas': typeof AppRtasRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/': typeof AppIndexRoute
  '/app/access/directory': typeof AppAccessDirectoryRoute
  '/app/access/roles': typeof AppAccessRolesRoute
  '/app/access/users': typeof AppAccessUsersRoute
  '/app/accounts/$accountId': typeof AppAccountsAccountIdRoute
  '/app/templates/$templateId': typeof AppTemplatesTemplateIdRoute
  '/app/access/': typeof AppAccessIndexRoute
  '/app/accounts/': typeof AppAccountsIndexRoute
  '/app/templates/': typeof AppTemplatesIndexRoute
  '/app/topics/': typeof AppTopicsIndexRoute
  '/app/accounts/$accountId_/analytics': typeof AppAccountsAccountIdAnalyticsRoute
  '/app/accounts/$accountId_/library': typeof AppAccountsAccountIdLibraryRoute
  '/app/accounts/$accountId_/settings': typeof AppAccountsAccountIdSettingsRoute
  '/app/accounts/$accountId_/stream-config': typeof AppAccountsAccountIdStreamConfigRoute
  '/app/accounts/$accountId_/reports/$reportId': typeof AppAccountsAccountIdReportsReportIdRoute
  '/app/accounts/$accountId_/rtas/$rtaId': typeof AppAccountsAccountIdRtasRtaIdRoute
  '/app/accounts/$accountId_/templates/$templateId': typeof AppAccountsAccountIdTemplatesTemplateIdRoute
  '/app/accounts/$accountId_/coverage-lists/': typeof AppAccountsAccountIdCoverageListsIndexRoute
  '/app/accounts/$accountId_/reports/': typeof AppAccountsAccountIdReportsIndexRoute
  '/app/accounts/$accountId_/rtas/': typeof AppAccountsAccountIdRtasIndexRoute
  '/app/accounts/$accountId_/templates/': typeof AppAccountsAccountIdTemplatesIndexRoute
  '/app/accounts/$accountId_/topics/': typeof AppAccountsAccountIdTopicsIndexRoute
  '/app/accounts/$accountId_/subaccounts/$subaccountId/analytics': typeof AppAccountsAccountIdSubaccountsSubaccountIdAnalyticsRoute
  '/app/accounts/$accountId_/subaccounts/$subaccountId/coverage-lists': typeof AppAccountsAccountIdSubaccountsSubaccountIdCoverageListsRoute
  '/app/accounts/$accountId_/subaccounts/$subaccountId/library': typeof AppAccountsAccountIdSubaccountsSubaccountIdLibraryRoute
  '/app/accounts/$accountId_/subaccounts/$subaccountId/reports': typeof AppAccountsAccountIdSubaccountsSubaccountIdReportsRoute
  '/app/accounts/$accountId_/subaccounts/$subaccountId/rtas': typeof AppAccountsAccountIdSubaccountsSubaccountIdRtasRoute
  '/app/accounts/$accountId_/subaccounts/$subaccountId/stream-config': typeof AppAccountsAccountIdSubaccountsSubaccountIdStreamConfigRoute
  '/app/accounts/$accountId_/subaccounts/$subaccountId/templates': typeof AppAccountsAccountIdSubaccountsSubaccountIdTemplatesRoute
  '/app/accounts/$accountId_/topics/$subaccountId/new': typeof AppAccountsAccountIdTopicsSubaccountIdNewRoute
  '/app/accounts/$accountId_/topics/$subaccountId/resources': typeof AppAccountsAccountIdTopicsSubaccountIdResourcesRoute
  '/app/accounts/$accountId_/subaccounts/$subaccountId/': typeof AppAccountsAccountIdSubaccountsSubaccountIdIndexRoute
  '/app/accounts/$accountId_/topics/$subaccountId/': typeof AppAccountsAccountIdTopicsSubaccountIdIndexRoute
  '/app/accounts/$accountId_/reports/$reportId_/issues/$issueId': typeof AppAccountsAccountIdReportsReportIdIssuesIssueIdRoute
  '/app/accounts/$accountId_/topics/$subaccountId/$topicId/edit': typeof AppAccountsAccountIdTopicsSubaccountIdTopicIdEditRoute
  '/app/accounts/$accountId_/reports/$reportId_/issues/': typeof AppAccountsAccountIdReportsReportIdIssuesIndexRoute
  '/app/accounts/$accountId_/topics/$subaccountId/$topicId/': typeof AppAccountsAccountIdTopicsSubaccountIdTopicIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/app/access'
    | '/app/guide'
    | '/app/lists'
    | '/app/reports'
    | '/app/rtas'
    | '/app/settings'
    | '/app/'
    | '/app/access/directory'
    | '/app/access/roles'
    | '/app/access/users'
    | '/app/accounts/$accountId'
    | '/app/templates/$templateId'
    | '/app/access/'
    | '/app/accounts/'
    | '/app/templates/'
    | '/app/topics/'
    | '/app/accounts/$accountId/analytics'
    | '/app/accounts/$accountId/library'
    | '/app/accounts/$accountId/settings'
    | '/app/accounts/$accountId/stream-config'
    | '/app/accounts/$accountId/reports/$reportId'
    | '/app/accounts/$accountId/rtas/$rtaId'
    | '/app/accounts/$accountId/templates/$templateId'
    | '/app/accounts/$accountId/coverage-lists/'
    | '/app/accounts/$accountId/reports/'
    | '/app/accounts/$accountId/rtas/'
    | '/app/accounts/$accountId/templates/'
    | '/app/accounts/$accountId/topics/'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/analytics'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/coverage-lists'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/library'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/reports'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/rtas'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/stream-config'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/templates'
    | '/app/accounts/$accountId/topics/$subaccountId/new'
    | '/app/accounts/$accountId/topics/$subaccountId/resources'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/'
    | '/app/accounts/$accountId/topics/$subaccountId/'
    | '/app/accounts/$accountId/reports/$reportId/issues/$issueId'
    | '/app/accounts/$accountId/topics/$subaccountId/$topicId/edit'
    | '/app/accounts/$accountId/reports/$reportId/issues/'
    | '/app/accounts/$accountId/topics/$subaccountId/$topicId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app/guide'
    | '/app/lists'
    | '/app/reports'
    | '/app/rtas'
    | '/app/settings'
    | '/app'
    | '/app/access/directory'
    | '/app/access/roles'
    | '/app/access/users'
    | '/app/accounts/$accountId'
    | '/app/templates/$templateId'
    | '/app/access'
    | '/app/accounts'
    | '/app/templates'
    | '/app/topics'
    | '/app/accounts/$accountId/analytics'
    | '/app/accounts/$accountId/library'
    | '/app/accounts/$accountId/settings'
    | '/app/accounts/$accountId/stream-config'
    | '/app/accounts/$accountId/reports/$reportId'
    | '/app/accounts/$accountId/rtas/$rtaId'
    | '/app/accounts/$accountId/templates/$templateId'
    | '/app/accounts/$accountId/coverage-lists'
    | '/app/accounts/$accountId/reports'
    | '/app/accounts/$accountId/rtas'
    | '/app/accounts/$accountId/templates'
    | '/app/accounts/$accountId/topics'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/analytics'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/coverage-lists'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/library'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/reports'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/rtas'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/stream-config'
    | '/app/accounts/$accountId/subaccounts/$subaccountId/templates'
    | '/app/accounts/$accountId/topics/$subaccountId/new'
    | '/app/accounts/$accountId/topics/$subaccountId/resources'
    | '/app/accounts/$accountId/subaccounts/$subaccountId'
    | '/app/accounts/$accountId/topics/$subaccountId'
    | '/app/accounts/$accountId/reports/$reportId/issues/$issueId'
    | '/app/accounts/$accountId/topics/$subaccountId/$topicId/edit'
    | '/app/accounts/$accountId/reports/$reportId/issues'
    | '/app/accounts/$accountId/topics/$subaccountId/$topicId'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/app/access'
    | '/app/guide'
    | '/app/lists'
    | '/app/reports'
    | '/app/rtas'
    | '/app/settings'
    | '/app/'
    | '/app/access/directory'
    | '/app/access/roles'
    | '/app/access/users'
    | '/app/accounts/$accountId'
    | '/app/templates/$templateId'
    | '/app/access/'
    | '/app/accounts/'
    | '/app/templates/'
    | '/app/topics/'
    | '/app/accounts/$accountId_/analytics'
    | '/app/accounts/$accountId_/library'
    | '/app/accounts/$accountId_/settings'
    | '/app/accounts/$accountId_/stream-config'
    | '/app/accounts/$accountId_/reports/$reportId'
    | '/app/accounts/$accountId_/rtas/$rtaId'
    | '/app/accounts/$accountId_/templates/$templateId'
    | '/app/accounts/$accountId_/coverage-lists/'
    | '/app/accounts/$accountId_/reports/'
    | '/app/accounts/$accountId_/rtas/'
    | '/app/accounts/$accountId_/templates/'
    | '/app/accounts/$accountId_/topics/'
    | '/app/accounts/$accountId_/subaccounts/$subaccountId/analytics'
    | '/app/accounts/$accountId_/subaccounts/$subaccountId/coverage-lists'
    | '/app/accounts/$accountId_/subaccounts/$subaccountId/library'
    | '/app/accounts/$accountId_/subaccounts/$subaccountId/reports'
    | '/app/accounts/$accountId_/subaccounts/$subaccountId/rtas'
    | '/app/accounts/$accountId_/subaccounts/$subaccountId/stream-config'
    | '/app/accounts/$accountId_/subaccounts/$subaccountId/templates'
    | '/app/accounts/$accountId_/topics/$subaccountId/new'
    | '/app/accounts/$accountId_/topics/$subaccountId/resources'
    | '/app/accounts/$accountId_/subaccounts/$subaccountId/'
    | '/app/accounts/$accountId_/topics/$subaccountId/'
    | '/app/accounts/$accountId_/reports/$reportId_/issues/$issueId'
    | '/app/accounts/$accountId_/topics/$subaccountId/$topicId/edit'
    | '/app/accounts/$accountId_/reports/$reportId_/issues/'
    | '/app/accounts/$accountId_/topics/$subaccountId/$topicId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/access': {
      id: '/app/access'
      path: '/access'
      fullPath: '/app/access'
      preLoaderRoute: typeof AppAccessRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/guide': {
      id: '/app/guide'
      path: '/guide'
      fullPath: '/app/guide'
      preLoaderRoute: typeof AppGuideRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/lists': {
      id: '/app/lists'
      path: '/lists'
      fullPath: '/app/lists'
      preLoaderRoute: typeof AppListsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/reports': {
      id: '/app/reports'
      path: '/reports'
      fullPath: '/app/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/rtas': {
      id: '/app/rtas'
      path: '/rtas'
      fullPath: '/app/rtas'
      preLoaderRoute: typeof AppRtasRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/access/': {
      id: '/app/access/'
      path: '/'
      fullPath: '/app/access/'
      preLoaderRoute: typeof AppAccessIndexRouteImport
      parentRoute: typeof AppAccessRouteRoute
    }
    '/app/access/directory': {
      id: '/app/access/directory'
      path: '/directory'
      fullPath: '/app/access/directory'
      preLoaderRoute: typeof AppAccessDirectoryRouteImport
      parentRoute: typeof AppAccessRouteRoute
    }
    '/app/access/roles': {
      id: '/app/access/roles'
      path: '/roles'
      fullPath: '/app/access/roles'
      preLoaderRoute: typeof AppAccessRolesRouteImport
      parentRoute: typeof AppAccessRouteRoute
    }
    '/app/access/users': {
      id: '/app/access/users'
      path: '/users'
      fullPath: '/app/access/users'
      preLoaderRoute: typeof AppAccessUsersRouteImport
      parentRoute: typeof AppAccessRouteRoute
    }
    '/app/accounts/': {
      id: '/app/accounts/'
      path: '/accounts'
      fullPath: '/app/accounts/'
      preLoaderRoute: typeof AppAccountsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId': {
      id: '/app/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/app/accounts/$accountId'
      preLoaderRoute: typeof AppAccountsAccountIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/templates/': {
      id: '/app/templates/'
      path: '/templates'
      fullPath: '/app/templates/'
      preLoaderRoute: typeof AppTemplatesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/templates/$templateId': {
      id: '/app/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/app/templates/$templateId'
      preLoaderRoute: typeof AppTemplatesTemplateIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/topics/': {
      id: '/app/topics/'
      path: '/topics'
      fullPath: '/app/topics/'
      preLoaderRoute: typeof AppTopicsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/analytics': {
      id: '/app/accounts/$accountId_/analytics'
      path: '/accounts/$accountId/analytics'
      fullPath: '/app/accounts/$accountId/analytics'
      preLoaderRoute: typeof AppAccountsAccountIdAnalyticsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/library': {
      id: '/app/accounts/$accountId_/library'
      path: '/accounts/$accountId/library'
      fullPath: '/app/accounts/$accountId/library'
      preLoaderRoute: typeof AppAccountsAccountIdLibraryRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/settings': {
      id: '/app/accounts/$accountId_/settings'
      path: '/accounts/$accountId/settings'
      fullPath: '/app/accounts/$accountId/settings'
      preLoaderRoute: typeof AppAccountsAccountIdSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/stream-config': {
      id: '/app/accounts/$accountId_/stream-config'
      path: '/accounts/$accountId/stream-config'
      fullPath: '/app/accounts/$accountId/stream-config'
      preLoaderRoute: typeof AppAccountsAccountIdStreamConfigRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/coverage-lists/': {
      id: '/app/accounts/$accountId_/coverage-lists/'
      path: '/accounts/$accountId/coverage-lists'
      fullPath: '/app/accounts/$accountId/coverage-lists/'
      preLoaderRoute: typeof AppAccountsAccountIdCoverageListsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/reports/': {
      id: '/app/accounts/$accountId_/reports/'
      path: '/accounts/$accountId/reports'
      fullPath: '/app/accounts/$accountId/reports/'
      preLoaderRoute: typeof AppAccountsAccountIdReportsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/reports/$reportId': {
      id: '/app/accounts/$accountId_/reports/$reportId'
      path: '/accounts/$accountId/reports/$reportId'
      fullPath: '/app/accounts/$accountId/reports/$reportId'
      preLoaderRoute: typeof AppAccountsAccountIdReportsReportIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/rtas/': {
      id: '/app/accounts/$accountId_/rtas/'
      path: '/accounts/$accountId/rtas'
      fullPath: '/app/accounts/$accountId/rtas/'
      preLoaderRoute: typeof AppAccountsAccountIdRtasIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/rtas/$rtaId': {
      id: '/app/accounts/$accountId_/rtas/$rtaId'
      path: '/accounts/$accountId/rtas/$rtaId'
      fullPath: '/app/accounts/$accountId/rtas/$rtaId'
      preLoaderRoute: typeof AppAccountsAccountIdRtasRtaIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/templates/': {
      id: '/app/accounts/$accountId_/templates/'
      path: '/accounts/$accountId/templates'
      fullPath: '/app/accounts/$accountId/templates/'
      preLoaderRoute: typeof AppAccountsAccountIdTemplatesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/templates/$templateId': {
      id: '/app/accounts/$accountId_/templates/$templateId'
      path: '/accounts/$accountId/templates/$templateId'
      fullPath: '/app/accounts/$accountId/templates/$templateId'
      preLoaderRoute: typeof AppAccountsAccountIdTemplatesTemplateIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/topics/': {
      id: '/app/accounts/$accountId_/topics/'
      path: '/accounts/$accountId/topics'
      fullPath: '/app/accounts/$accountId/topics/'
      preLoaderRoute: typeof AppAccountsAccountIdTopicsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/subaccounts/$subaccountId/': {
      id: '/app/accounts/$accountId_/subaccounts/$subaccountId/'
      path: '/accounts/$accountId/subaccounts/$subaccountId'
      fullPath: '/app/accounts/$accountId/subaccounts/$subaccountId/'
      preLoaderRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/subaccounts/$subaccountId/analytics': {
      id: '/app/accounts/$accountId_/subaccounts/$subaccountId/analytics'
      path: '/accounts/$accountId/subaccounts/$subaccountId/analytics'
      fullPath: '/app/accounts/$accountId/subaccounts/$subaccountId/analytics'
      preLoaderRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdAnalyticsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/subaccounts/$subaccountId/coverage-lists': {
      id: '/app/accounts/$accountId_/subaccounts/$subaccountId/coverage-lists'
      path: '/accounts/$accountId/subaccounts/$subaccountId/coverage-lists'
      fullPath: '/app/accounts/$accountId/subaccounts/$subaccountId/coverage-lists'
      preLoaderRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdCoverageListsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/subaccounts/$subaccountId/library': {
      id: '/app/accounts/$accountId_/subaccounts/$subaccountId/library'
      path: '/accounts/$accountId/subaccounts/$subaccountId/library'
      fullPath: '/app/accounts/$accountId/subaccounts/$subaccountId/library'
      preLoaderRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdLibraryRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/subaccounts/$subaccountId/reports': {
      id: '/app/accounts/$accountId_/subaccounts/$subaccountId/reports'
      path: '/accounts/$accountId/subaccounts/$subaccountId/reports'
      fullPath: '/app/accounts/$accountId/subaccounts/$subaccountId/reports'
      preLoaderRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdReportsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/subaccounts/$subaccountId/rtas': {
      id: '/app/accounts/$accountId_/subaccounts/$subaccountId/rtas'
      path: '/accounts/$accountId/subaccounts/$subaccountId/rtas'
      fullPath: '/app/accounts/$accountId/subaccounts/$subaccountId/rtas'
      preLoaderRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdRtasRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/subaccounts/$subaccountId/stream-config': {
      id: '/app/accounts/$accountId_/subaccounts/$subaccountId/stream-config'
      path: '/accounts/$accountId/subaccounts/$subaccountId/stream-config'
      fullPath: '/app/accounts/$accountId/subaccounts/$subaccountId/stream-config'
      preLoaderRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdStreamConfigRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/subaccounts/$subaccountId/templates': {
      id: '/app/accounts/$accountId_/subaccounts/$subaccountId/templates'
      path: '/accounts/$accountId/subaccounts/$subaccountId/templates'
      fullPath: '/app/accounts/$accountId/subaccounts/$subaccountId/templates'
      preLoaderRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdTemplatesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/topics/$subaccountId/': {
      id: '/app/accounts/$accountId_/topics/$subaccountId/'
      path: '/accounts/$accountId/topics/$subaccountId'
      fullPath: '/app/accounts/$accountId/topics/$subaccountId/'
      preLoaderRoute: typeof AppAccountsAccountIdTopicsSubaccountIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/topics/$subaccountId/new': {
      id: '/app/accounts/$accountId_/topics/$subaccountId/new'
      path: '/accounts/$accountId/topics/$subaccountId/new'
      fullPath: '/app/accounts/$accountId/topics/$subaccountId/new'
      preLoaderRoute: typeof AppAccountsAccountIdTopicsSubaccountIdNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/topics/$subaccountId/resources': {
      id: '/app/accounts/$accountId_/topics/$subaccountId/resources'
      path: '/accounts/$accountId/topics/$subaccountId/resources'
      fullPath: '/app/accounts/$accountId/topics/$subaccountId/resources'
      preLoaderRoute: typeof AppAccountsAccountIdTopicsSubaccountIdResourcesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/reports/$reportId_/issues/': {
      id: '/app/accounts/$accountId_/reports/$reportId_/issues/'
      path: '/accounts/$accountId/reports/$reportId/issues'
      fullPath: '/app/accounts/$accountId/reports/$reportId/issues/'
      preLoaderRoute: typeof AppAccountsAccountIdReportsReportIdIssuesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/reports/$reportId_/issues/$issueId': {
      id: '/app/accounts/$accountId_/reports/$reportId_/issues/$issueId'
      path: '/accounts/$accountId/reports/$reportId/issues/$issueId'
      fullPath: '/app/accounts/$accountId/reports/$reportId/issues/$issueId'
      preLoaderRoute: typeof AppAccountsAccountIdReportsReportIdIssuesIssueIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/topics/$subaccountId/$topicId/': {
      id: '/app/accounts/$accountId_/topics/$subaccountId/$topicId/'
      path: '/accounts/$accountId/topics/$subaccountId/$topicId'
      fullPath: '/app/accounts/$accountId/topics/$subaccountId/$topicId/'
      preLoaderRoute: typeof AppAccountsAccountIdTopicsSubaccountIdTopicIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/accounts/$accountId_/topics/$subaccountId/$topicId/edit': {
      id: '/app/accounts/$accountId_/topics/$subaccountId/$topicId/edit'
      path: '/accounts/$accountId/topics/$subaccountId/$topicId/edit'
      fullPath: '/app/accounts/$accountId/topics/$subaccountId/$topicId/edit'
      preLoaderRoute: typeof AppAccountsAccountIdTopicsSubaccountIdTopicIdEditRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppAccessRouteRouteChildren {
  AppAccessDirectoryRoute: typeof AppAccessDirectoryRoute
  AppAccessRolesRoute: typeof AppAccessRolesRoute
  AppAccessUsersRoute: typeof AppAccessUsersRoute
  AppAccessIndexRoute: typeof AppAccessIndexRoute
}

const AppAccessRouteRouteChildren: AppAccessRouteRouteChildren = {
  AppAccessDirectoryRoute: AppAccessDirectoryRoute,
  AppAccessRolesRoute: AppAccessRolesRoute,
  AppAccessUsersRoute: AppAccessUsersRoute,
  AppAccessIndexRoute: AppAccessIndexRoute,
}

const AppAccessRouteRouteWithChildren = AppAccessRouteRoute._addFileChildren(
  AppAccessRouteRouteChildren,
)

interface AppRouteRouteChildren {
  AppAccessRouteRoute: typeof AppAccessRouteRouteWithChildren
  AppGuideRoute: typeof AppGuideRoute
  AppListsRoute: typeof AppListsRoute
  AppReportsRoute: typeof AppReportsRoute
  AppRtasRoute: typeof AppRtasRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountsAccountIdRoute: typeof AppAccountsAccountIdRoute
  AppTemplatesTemplateIdRoute: typeof AppTemplatesTemplateIdRoute
  AppAccountsIndexRoute: typeof AppAccountsIndexRoute
  AppTemplatesIndexRoute: typeof AppTemplatesIndexRoute
  AppTopicsIndexRoute: typeof AppTopicsIndexRoute
  AppAccountsAccountIdAnalyticsRoute: typeof AppAccountsAccountIdAnalyticsRoute
  AppAccountsAccountIdLibraryRoute: typeof AppAccountsAccountIdLibraryRoute
  AppAccountsAccountIdSettingsRoute: typeof AppAccountsAccountIdSettingsRoute
  AppAccountsAccountIdStreamConfigRoute: typeof AppAccountsAccountIdStreamConfigRoute
  AppAccountsAccountIdReportsReportIdRoute: typeof AppAccountsAccountIdReportsReportIdRoute
  AppAccountsAccountIdRtasRtaIdRoute: typeof AppAccountsAccountIdRtasRtaIdRoute
  AppAccountsAccountIdTemplatesTemplateIdRoute: typeof AppAccountsAccountIdTemplatesTemplateIdRoute
  AppAccountsAccountIdCoverageListsIndexRoute: typeof AppAccountsAccountIdCoverageListsIndexRoute
  AppAccountsAccountIdReportsIndexRoute: typeof AppAccountsAccountIdReportsIndexRoute
  AppAccountsAccountIdRtasIndexRoute: typeof AppAccountsAccountIdRtasIndexRoute
  AppAccountsAccountIdTemplatesIndexRoute: typeof AppAccountsAccountIdTemplatesIndexRoute
  AppAccountsAccountIdTopicsIndexRoute: typeof AppAccountsAccountIdTopicsIndexRoute
  AppAccountsAccountIdSubaccountsSubaccountIdAnalyticsRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdAnalyticsRoute
  AppAccountsAccountIdSubaccountsSubaccountIdCoverageListsRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdCoverageListsRoute
  AppAccountsAccountIdSubaccountsSubaccountIdLibraryRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdLibraryRoute
  AppAccountsAccountIdSubaccountsSubaccountIdReportsRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdReportsRoute
  AppAccountsAccountIdSubaccountsSubaccountIdRtasRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdRtasRoute
  AppAccountsAccountIdSubaccountsSubaccountIdStreamConfigRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdStreamConfigRoute
  AppAccountsAccountIdSubaccountsSubaccountIdTemplatesRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdTemplatesRoute
  AppAccountsAccountIdTopicsSubaccountIdNewRoute: typeof AppAccountsAccountIdTopicsSubaccountIdNewRoute
  AppAccountsAccountIdTopicsSubaccountIdResourcesRoute: typeof AppAccountsAccountIdTopicsSubaccountIdResourcesRoute
  AppAccountsAccountIdSubaccountsSubaccountIdIndexRoute: typeof AppAccountsAccountIdSubaccountsSubaccountIdIndexRoute
  AppAccountsAccountIdTopicsSubaccountIdIndexRoute: typeof AppAccountsAccountIdTopicsSubaccountIdIndexRoute
  AppAccountsAccountIdReportsReportIdIssuesIssueIdRoute: typeof AppAccountsAccountIdReportsReportIdIssuesIssueIdRoute
  AppAccountsAccountIdTopicsSubaccountIdTopicIdEditRoute: typeof AppAccountsAccountIdTopicsSubaccountIdTopicIdEditRoute
  AppAccountsAccountIdReportsReportIdIssuesIndexRoute: typeof AppAccountsAccountIdReportsReportIdIssuesIndexRoute
  AppAccountsAccountIdTopicsSubaccountIdTopicIdIndexRoute: typeof AppAccountsAccountIdTopicsSubaccountIdTopicIdIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAccessRouteRoute: AppAccessRouteRouteWithChildren,
  AppGuideRoute: AppGuideRoute,
  AppListsRoute: AppListsRoute,
  AppReportsRoute: AppReportsRoute,
  AppRtasRoute: AppRtasRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountsAccountIdRoute: AppAccountsAccountIdRoute,
  AppTemplatesTemplateIdRoute: AppTemplatesTemplateIdRoute,
  AppAccountsIndexRoute: AppAccountsIndexRoute,
  AppTemplatesIndexRoute: AppTemplatesIndexRoute,
  AppTopicsIndexRoute: AppTopicsIndexRoute,
  AppAccountsAccountIdAnalyticsRoute: AppAccountsAccountIdAnalyticsRoute,
  AppAccountsAccountIdLibraryRoute: AppAccountsAccountIdLibraryRoute,
  AppAccountsAccountIdSettingsRoute: AppAccountsAccountIdSettingsRoute,
  AppAccountsAccountIdStreamConfigRoute: AppAccountsAccountIdStreamConfigRoute,
  AppAccountsAccountIdReportsReportIdRoute:
    AppAccountsAccountIdReportsReportIdRoute,
  AppAccountsAccountIdRtasRtaIdRoute: AppAccountsAccountIdRtasRtaIdRoute,
  AppAccountsAccountIdTemplatesTemplateIdRoute:
    AppAccountsAccountIdTemplatesTemplateIdRoute,
  AppAccountsAccountIdCoverageListsIndexRoute:
    AppAccountsAccountIdCoverageListsIndexRoute,
  AppAccountsAccountIdReportsIndexRoute: AppAccountsAccountIdReportsIndexRoute,
  AppAccountsAccountIdRtasIndexRoute: AppAccountsAccountIdRtasIndexRoute,
  AppAccountsAccountIdTemplatesIndexRoute:
    AppAccountsAccountIdTemplatesIndexRoute,
  AppAccountsAccountIdTopicsIndexRoute: AppAccountsAccountIdTopicsIndexRoute,
  AppAccountsAccountIdSubaccountsSubaccountIdAnalyticsRoute:
    AppAccountsAccountIdSubaccountsSubaccountIdAnalyticsRoute,
  AppAccountsAccountIdSubaccountsSubaccountIdCoverageListsRoute:
    AppAccountsAccountIdSubaccountsSubaccountIdCoverageListsRoute,
  AppAccountsAccountIdSubaccountsSubaccountIdLibraryRoute:
    AppAccountsAccountIdSubaccountsSubaccountIdLibraryRoute,
  AppAccountsAccountIdSubaccountsSubaccountIdReportsRoute:
    AppAccountsAccountIdSubaccountsSubaccountIdReportsRoute,
  AppAccountsAccountIdSubaccountsSubaccountIdRtasRoute:
    AppAccountsAccountIdSubaccountsSubaccountIdRtasRoute,
  AppAccountsAccountIdSubaccountsSubaccountIdStreamConfigRoute:
    AppAccountsAccountIdSubaccountsSubaccountIdStreamConfigRoute,
  AppAccountsAccountIdSubaccountsSubaccountIdTemplatesRoute:
    AppAccountsAccountIdSubaccountsSubaccountIdTemplatesRoute,
  AppAccountsAccountIdTopicsSubaccountIdNewRoute:
    AppAccountsAccountIdTopicsSubaccountIdNewRoute,
  AppAccountsAccountIdTopicsSubaccountIdResourcesRoute:
    AppAccountsAccountIdTopicsSubaccountIdResourcesRoute,
  AppAccountsAccountIdSubaccountsSubaccountIdIndexRoute:
    AppAccountsAccountIdSubaccountsSubaccountIdIndexRoute,
  AppAccountsAccountIdTopicsSubaccountIdIndexRoute:
    AppAccountsAccountIdTopicsSubaccountIdIndexRoute,
  AppAccountsAccountIdReportsReportIdIssuesIssueIdRoute:
    AppAccountsAccountIdReportsReportIdIssuesIssueIdRoute,
  AppAccountsAccountIdTopicsSubaccountIdTopicIdEditRoute:
    AppAccountsAccountIdTopicsSubaccountIdTopicIdEditRoute,
  AppAccountsAccountIdReportsReportIdIssuesIndexRoute:
    AppAccountsAccountIdReportsReportIdIssuesIndexRoute,
  AppAccountsAccountIdTopicsSubaccountIdTopicIdIndexRoute:
    AppAccountsAccountIdTopicsSubaccountIdTopicIdIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
